module.exports = __webpack_public_path__ + "img/CheckMark_large.7eacd4c7.svg";